import TabOptions from '../options';

export const SignatureMechanisms = {
  Electronic: 1,
  Manual: 2,
};

export class Model {
  signatureMechanismId = null;
  evaluatorName = null;
  evaluatorInitialName = null;
  evaluatorLastName = null;
  evaluatorSecondLastName = null;
  evaluatorDate = null;
  signedDocumentId = null;
  signedDocumentName = null;
}

const buildSignaturePayload = (model) => {
  const isManual =
    Number(model.signatureMechanismId) === SignatureMechanisms.Manual;

  return {
    ...model,
    evaluatorName: isManual ? model.evaluatorName || '' : '',
    evaluatorInitialName: isManual ? model.evaluatorInitialName || '' : '',
    evaluatorLastName: isManual ? model.evaluatorLastName || '' : '',
    evaluatorSecondLastName: isManual
      ? model.evaluatorSecondLastName || ''
      : '',
    evaluatorDate: isManual ? model.evaluatorDate || '' : '',
    signedDocumentId: isManual ? model.signedDocumentId || '' : '',
    signedDocumentName: isManual ? model.signedDocumentName || '' : '',
  };
};

export class Tab {
  id = 'Signature';
  title = 'Firma';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...buildSignaturePayload(model),
    };
  };
}
export default new Tab();
